import type { KvStorage } from '@/shared/lib/storage';

const KEY = 'infiltre:online:name:v1';

/**
 * Read the last successfully-used online display name.
 *
 * Persisted by `useLobbyActions` after every successful create / join so the
 * next session pre-fills the input — including via the `/room/:code`
 * deep-link fast-join path.
 */
export const loadSavedName = (storage: KvStorage): string | null => {
  const v = storage.get<unknown>(KEY);
  return typeof v === 'string' && v.trim().length > 0 ? v : null;
};

/** Save the user's display name (trimmed + length-capped). No-op for empty. */
export const saveName = (storage: KvStorage, name: string): void => {
  const trimmed = name.trim();
  if (trimmed.length === 0) return;
  storage.set(KEY, trimmed.slice(0, 32));
};
